module.exports = __webpack_public_path__ + "static/media/You.6a864e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/You.png
// module id = 966
// module chunks = 2